import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, fmt } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STATUS_COLOR = {
  awaiting_payment: "text-amber-400 border-amber-400/30",
  pending: "text-amber-400 border-amber-400/30",
  paid: "text-cyan-400 border-cyan-400/30",
  shipped: "text-green-400 border-green-400/30",
  cancelled: "text-red-400 border-red-400/30",
};

const STATUS_LABEL = {
  awaiting_payment: "awaiting payment",
  pending: "pending",
  paid: "paid",
  shipped: "shipped",
  cancelled: "cancelled",
};

export default function Account() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/orders/me").then((r) => setOrders(r.data));
  }, [user]);

  if (loading) return <div className="py-20 text-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: "/account" }} />;

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-12" data-testid="account-page">
      <div className="label-mono text-cyan-400 mb-3">/ ACCOUNT</div>
      <h1 className="text-4xl font-medium tracking-tight">Welcome, {user.name}</h1>
      <p className="mt-2 text-slate-400 text-sm">{user.email}</p>

      <h2 className="mt-12 text-xl font-medium border-b border-white/5 pb-3">Order History</h2>
      {orders.length === 0 ? (
        <p className="mt-8 text-slate-500">You haven&apos;t placed any orders yet.</p>
      ) : (
        <div className="mt-6 space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border border-white/5 p-5" data-testid={`order-${o.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                  <div className="font-mono text-xs text-slate-500">ORDER #{o.id.slice(0, 8).toUpperCase()}</div>
                  <div className="text-sm text-slate-400 mt-1">{new Date(o.created_at).toLocaleString()}</div>
                </div>
                <div className={`label-mono px-3 py-1 border ${STATUS_COLOR[o.status] || "text-slate-400 border-white/10"}`}>
                  {STATUS_LABEL[o.status] || o.status}
                </div>
                <div className="font-mono text-lg text-cyan-400">{fmt(o.total)}</div>
              </div>
              <div className="mt-4 space-y-1 text-sm">
                {o.items.map((i, idx) => (
                  <div key={idx} className="flex justify-between text-slate-300">
                    <span>{i.name} <span className="text-slate-500">× {i.quantity}</span></span>
                    <span className="font-mono">{fmt(i.line_total)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
